export default {
  async getContentSite(slug, siteName) {
    return await fetch(
      `${process.env.VUE_APP_API_URL}/site?slug=${slug}&siteName=${siteName}`
    );
  }
};
